import { render, staticRenderFns } from "./IconSvgSort.vue?vue&type=template&id=617831e2&scoped=true&"
import script from "./IconSvgSort.vue?vue&type=script&lang=js&"
export * from "./IconSvgSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617831e2",
  null
  
)

export default component.exports